import axios from "axios"

import { OpenAPI } from "../client"
import type { ApiRequestOptions } from "../client/core/ApiRequestOptions"
import { getHeaders, getQueryString } from "../client/core/request"

// parseBlobErrorMessage extracts backend JSON error text from blob responses.
const parseBlobErrorMessage = async (blob: Blob) => {
  try {
    const text = await blob.text()
    const payload = JSON.parse(text) as { error?: string }
    return payload.error || null
  } catch {
    return null
  }
}

// parseFileName reads a standard filename value from Content-Disposition.
const parseFileName = (value?: string) => {
  return value?.match(/filename="?([^"]+)"?$/i)?.[1]
}

// ClientDataExportApi downloads the separate read-only data portability archive.
export const ClientDataExportApi = {
  async downloadArchive(params?: { includeFiles?: boolean }) {
    const options: ApiRequestOptions = {
      method: "GET",
      url: "/v1/license/client-data-export",
      query: {
        include_files: params?.includeFiles ?? true,
      },
    }
    const headers = await getHeaders(OpenAPI, options)
    try {
      const response = await axios.request<Blob>({
        method: options.method,
        url: `${OpenAPI.BASE}${options.url}${options.query ? getQueryString(options.query) : ""}`,
        headers,
        withCredentials: OpenAPI.WITH_CREDENTIALS,
        responseType: "blob",
      })

      return {
        blob: response.data,
        fileName:
          parseFileName(response.headers["content-disposition"]) ||
          "stockerra-client-data.zip",
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const blob = error.response?.data
        const backendMessage =
          blob instanceof Blob ? await parseBlobErrorMessage(blob) : null
        throw new Error(
          backendMessage || "Nie udało się pobrać archiwum danych klienta.",
        )
      }
      throw error
    }
  },
}
